import { REGEX_VALID_IMAGE } from "../constants/regex.constants";

export const validateURL = (url?: string) => {
  if (!url || (url && !REGEX_VALID_IMAGE.test(url))) return ''
  return url
}
